export interface MileageEntry {
  id: string;
  date: string;
  startLocation: string;
  endLocation: string;
  miles: number;
  purpose: string;
  rate: number; // IRS standard mileage rate
  deduction: number;
  userId: string;
}

// IRS Standard Mileage Rates
export const MILEAGE_RATES = {
  2025: 0.70, // 70 cents per mile (update when IRS announces official rate)
  2024: 0.67, // 67 cents per mile
  2023: 0.655, // 65.5 cents per mile
  2022: 0.625 // 62.5 cents per mile (Jan-Jun), 0.655 (Jul-Dec)
};

export function getCurrentMileageRate(year: number = new Date().getFullYear()): number {
  // If year is not in our table, use the most recent year's rate
  const availableYears = Object.keys(MILEAGE_RATES).map(Number).sort((a, b) => b - a);
  const closestYear = availableYears.find(y => y <= year) || availableYears[0];
  return MILEAGE_RATES[closestYear as keyof typeof MILEAGE_RATES] || 0.67;
}

export function calculateMileageDeduction(miles: number, year: number = new Date().getFullYear()): number {
  const rate = getCurrentMileageRate(year);
  return miles * rate;
}

export function storeMileageEntry(entry: MileageEntry): void {
  const entries = getMileageEntries(entry.userId);
  entries.push(entry);
  localStorage.setItem(`mileage_entries_${entry.userId}`, JSON.stringify(entries));
}

export function getMileageEntries(userId: string): MileageEntry[] {
  const stored = localStorage.getItem(`mileage_entries_${userId}`);
  return stored ? JSON.parse(stored) : [];
}

export function deleteMileageEntry(entryId: string, userId: string): void {
  const entries = getMileageEntries(userId);
  const filtered = entries.filter(e => e.id !== entryId);
  localStorage.setItem(`mileage_entries_${userId}`, JSON.stringify(filtered));
}

export function getTotalMileageDeduction(userId: string, year?: number): number {
  const entries = getMileageEntries(userId);
  
  if (year) {
    const filtered = entries.filter(e => new Date(e.date).getFullYear() === year);
    return filtered.reduce((sum, entry) => sum + entry.deduction, 0);
  }
  
  return entries.reduce((sum, entry) => sum + entry.deduction, 0);
}

export function getTotalMiles(userId: string, year?: number): number {
  const entries = getMileageEntries(userId);
  
  if (year) {
    const filtered = entries.filter(e => new Date(e.date).getFullYear() === year);
    return filtered.reduce((sum, entry) => sum + entry.miles, 0);
  }
  
  return entries.reduce((sum, entry) => sum + entry.miles, 0);
}
